import { PropsWithChildren } from 'react'
import Styles from './BrandKitTextStyles.module.scss'

interface Props extends PropsWithChildren<{ style?: React.CSSProperties }> {}

export const TextStylePreview = ({ children, style }: Props) => (
  <div className={Styles.textStyle} style={style}>
    {children}
  </div>
)
